// We use this to get correct label date format based on locale
export const getDateInputFormat = () => {
  const testDate = new Date(2024, 0, 2); // January 2, 2024
  const formatter = new Intl.DateTimeFormat(navigator.language, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const formattedDate = formatter.format(testDate);

  // Replace example numbers with placeholders
  return formattedDate
    .replace('2024', 'YYYY')
    .replace('01', 'MM')
    .replace('02', 'DD');
};

// Date input expects date in format of YYYY-MM-DD
export const dateUtcToInputValue = (date: Date) => {
  return date.toISOString().slice(0, 10);
};

// Convert UTC Date object to get date in YYYY-MM-DD format and time in HH:MM format
// type="time" input expects time in HH:MM format
export const parseDateTime = (dateTimeString: string | undefined) => {
  const dateObject = dateTimeString ? new Date(dateTimeString) : new Date();

  const date = dateUtcToInputValue(dateObject);

  const time = Intl.DateTimeFormat(navigator.language, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(dateObject);

  return {
    date,
    time,
  };
};

// Final conversion from local state to ISOString expected by core
export const toISOString = (date: string, time: string) => {
  const [year, month, day] = date.split('-');
  const [hours, minutes] = time.split(':');

  const finalDateTime = new Date(
    Number.parseInt(year),
    Number.parseInt(month) - 1,
    Number.parseInt(day),
    Number.parseInt(hours, 10),
    Number.parseInt(minutes, 10)
  );

  // Because we are using default date and time input, we shouldn't get invalid date, but just in case
  if (Number.isNaN(finalDateTime.getTime())) {
    return '';
  }

  return finalDateTime.toISOString();
};

export const setInitialState = ({
  defaultValue,
  dataKey,
}: {
  defaultValue: string | undefined;
  dataKey: string;
}) => {
  const { date, time } = parseDateTime(defaultValue);

  return {
    [`${dataKey}_date`]: date,
    [`${dataKey}_time`]: time,
  };
};
